"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHebrew = exports.filter = void 0;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var filter = function filter(_ref) {
  var string = _ref.string,
      filters = _ref.filters;

  var _string = string.slice(0);

  filters.forEach(function (filter) {
    var _filter = _slicedToArray(filter, 2),
        replace = _filter[0],
        replacer = _filter[1];

    _string = _string.replace(replace, replacer);
  });
  return _string;
};

exports.filter = filter;

var isHebrew = function isHebrew(string) {
  var hebrewChars = string.match(/[\u0590-\u05FF]/g) || [];
  var percent = hebrewChars.length / string.length;
  return percent > 0.75;
};

exports.isHebrew = isHebrew;